module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/test-tube.6373f06af5b1ddb4.gif";